// 引入通用common
import commons from '@/util/commons';
import { EventBus } from '@/util/eventBus'; // 引入事件总线
import * as types from '@/store/types';
import {
  apiUserlogin,
  apiUserinfo,
  apiDepartment,
  apiRole,
  apiUsermodify,
  apiUserlogs,
  apiUserlists,
  apiUserdel,
  apiUserstore,
  apiUsercontrolstore,
  apiUsercontrolmodify,
  apiUsercontrol,
  apiUsercontroldel,
  apiUserall,
  apiUsercontrolinfo,
  apiRolestore,
  apiRolemodify,
  apiRolelists,
  apiRoledel,
  apiRoleinfo,
  apiUserlogsalls,
  apiUsercolleague,
  apiUsercolleaguemodify,
  apiUsercolleagueinfo,
  apiTagesalls,
  apiTagesdel,
  apiTagesmodify,
  apiTagesstore,
  apiTagesinfo,
  apiResumetagesalls,
  apiResumetagesdel,
  apiResumetagesmodify,
  apiResumetagesstore,
  apiResumetagesinfo,
  apiResumetagesArr,
  apiResumepositionArr,
  apiResumelist,
  apiResumeliststore,
  apiResumelistinfo,
  apiResumelistmodify,
  apiResumeRefreshlist,
  apiResumelistdel,
  apiResumeinterview,
  apiResumeinterviewstore,
  apiResumeinterviewdel,
  apiResumetrace,
  apiResumetracestore,
  apiResumeworktable,
  apiSignevent,
  apiSigneventusers,
  apiResumeinterviewrefreshlist,
  apiSigneventstore,
  apiSigneventinfo,
  apiSigneventmodify,
  apiSigneventdel,
  apiSignlog,
  apiSignloginfo,
  apiSigneventjoinlist,
  apiStatisticsvisitmy,
  apiStatisticsvisitmyline,
  apiStatisticsvisitall,
  apiStatisticsvisitallline,
  apiUsernotice,
  apiUsernoticestore,
  apiUsernoticeinfo,
  apiUsernoticemodify,
  apiUsernoticedel,
  apiUsercontacts,
  apiUsercontactsstore,
  apiUsercontactsinfo,
  apiUsercontactsmodify,
  apiUsercontactsdel,
  apiMemo,
  apiMemostore,
  apiMemoinfo,
  apiMemomodify,
  apiMemodel,
  apiMessage,
  apiMessagestate,
  apiStatisticshome,
  apiCrmlist,
  apiCrmTages,
  apiCrmLogs,
  apiCrmInfo,
  apiCrmTrace,
  apiCrmTraceLabel,
  apiUserZaizhi,
  apiCrmTracestore,
  apiCrmModify,
  apiCrmContact,
  apiCrmContactStore,
  apiCrmContactDel
  ,
  apiCrmPact,
  apiCrmPactStore,
  apiCrmPactDel,
  apiCrmPactTages,
  apiCrmFiles,
  apiCrmFilesStore,
  apiCrmFilesDel,
  apiCrmShare,
  apiCrmDutyuid,
  apiCrmSetchance,
  apiCrmSetclient,
  apiCrmDel,
  apiCrmBlackapply,
  apiCrmProtect,
  apiCrmSetlatent,
  apiCrmStore,
  apiUpdatetoken,
  apiCrmRecover,
  apiCrmblackstore,
  apiCrmblackmodify,
  apiCrmblacklists,
  apiCrmblackdel,
  apiCrmblackstate,
  apiCrmblackinfo,
  apiStatisticscrmchancehome,
  apiStatisticscrmchancedataone,
  apiStatisticscrmchancedatatow,
  apiStatisticscrmdataone,
  apiStatisticscrmdatatow,
  apiStatisticscrmdatathree,
  apiStatisticscrmdatafour,
  apiStatisticscrmdatafive,
  apiCrmPactInfo,
  apiCrmPactTrace,
  apiCrmPactTracestore,
  apiCrmPactFilesStore,
  apiCrmPactFilesDel,
  apiCrmPactFiles,
  apiCrmImport,
  apiCrmImportshow,
  apiStatisticscrmdatahome,
  apiUsertongshi,
  apiCrmviewcontact,
  apiStatisticsviewlogs,
  apiViewlogs,
  apiCrmmap,
  apiNodealls,
  apiSignbinding,
  apiBindinginfo,
  apiSignfindtoken,
  apiSignmakeqrcode,
  apiExternalsign,
  apiExternalsigninfo,
  apiCrmdestroy,
  apiCrmTracedel,
  apiCrmsavezhuangtai,
  apiCrmcontactrepeat,
  apiWarehousetages,
  apiWarehousealltages,
  apiWarehousetagesstore,
  apiWarehousetagesdel,
  apiWarehousetagesinfo,
  apiWarehousetagesmodify,
  apiWarehousegoodslist,
  apiWarehousegoodstagesarr,
  apiWarehousegoodsstore,
  apiWarehousegoodsinfo,
  apiWarehousegoodsdel,
  apiWarehousegoodsrefreshlist,
  apiWarehousegoodsmodify,
  apiWarehousegoodsimgs,
  apiWarehousegoodsimgsdel,
  apiWarehousebillinit,
  apiWarehousecheckclient,
  apiWarehousesearchingrepertory,
  apiWarehousesearchserial,
  apiWarehousecheckzhanghu,
  apiWarehousegetclientyingshou,
  apiWarehousereadbillsexcel,
  apiWarehousestorebills,
  apiWarehouserepertory,
  apiWarehouseselllog,
  apiWarehousebillsinfo,
  apiWarehousebillsstoreaccounts,
  apiWarehouseUpdateBillsinfo,
  apiWarehousebillscancellation,
  apiWarehousebillsgoods,
  apiWarehousebillsaccounts,
  apiWarehousesearchproduct,
  apiWarehousebillsreturninfo,
  apiWarehouseBillsReturn,
  apiWarehouseBillsStoreReturn,
  apiWarehouseaccountintstore,
  apiWarehouseBillsStoreAccounts,
  apiWarehouseaccountsinfo,
  apiWarehouseBillsDelAccounts,
  apiWarehouseGoodsNumDetail,
  apiMakewarehousegoodsnum,
  apiOnerepertory,
  apiDealeruserlist,
  apiDealeruserStore,
  apiDealeruserInfo,
  apiDealeruserModify,
  apiDealeruserdel,
  apiDealeruserremove,
  apiDealerimpowerlist,
  apiDealerimpowerone,
  apiDealerImpowerStore,
  apiDealerImpowerModify,
  apiDealerImpowerdel,
  apiDealerdiscountone,
  apiDealerDiscountStore,
  apiDealerDiscountModify,
  apiDealerDiscountdel,
  apiDealerdiscountlist,
  apiDealerDiscountdelall,
  apiDealerPricelist,
  apiDealerPriceone,
  apiDealerPriceStore,
  apiDealerPriceModify,
  apiDealerPricedel,
  apiDealerPricedelall,
  apiDealerOrderlist,
  apiDealerOrderone,
  apiDealerOrdersend,
  apiDealerOrdersendcode,
  apiDealerOrdersendgoods,
  apiDealerSendOne,
  apiDealerOrdercancelsend,
  apiDealerOrdercancel,
  apiDealerOrderinvoice,
  apiDealerOrderInvoiceInfo,
  apiDealerOrderInvoiceSaveContent,
  apiDealerOrderInvoiceDelFiles,
  apiDealerOrderInvoiceSaveState,
  apiWarehousecheckgoodstages,
  apiWarehouseSaveGoodsContents,
  apiWarehouseFilesStore,
  apiWarehouseFilesModify,
  apiWarehouseFilesDel,
  apiWarehouseFilesInfo,
  apiWarehouseFilesList,
  articleList,
  articleDel,
  articleInfo,
  articleStore,
  articleModify,
  apiWarehouseGoodsgrouplist,
  apiWarehouseGoodsgroupstore,
  apiWarehouseGoodsgroupinfo,
  apiWarehouseGoodsgroupmodify,
  apiWarehouseGoodsgroupdel,
  apiDealerhome,
  apiDealerone,
  apiWarehousehome,
  apiWarehouseone,
  apiStatistcssjtjcangku,
  apiStatistcswarehousejxsdata,
  apiStatistcswarehousejxsline,
  apiWarehousesupplierdel,
  apiWarehousesupplierremove,
  apiWarehousesupplierStore,
  apiWarehousesupplierInfo,
  apiWarehousesupplierModify,
  apiWarehousesupplierlist,
  apiWarehousemakebatchsearch,
  apiWarehousemakebatchaccount,
  apiWarehousesearchcode,
  apiWarehouseimport,
  apiWarehouseimportdata,
  apiWarehousegoodscatalog,
  apiWarehouseresetchaoshi,
  apiWarehousebillsgoodscghz,
  apiCrmgysall,
  apiWarehousetimedtask,
  apiSettingsetshipments,
  apiSysheadimgsList,
  apiSysheadimgsStore,
  apiSysheadimgsModify,
  apiSysheadimgsDel,
  apiSysheadimgsInfo,
  apiMallDiscountpingtaistore,
  apiMallDiscountzhijiangstore,
  apiMallDiscountzhekoustore,
  apiMallDiscountmanjianstore,
  apiMallDiscountnavigation,
  apiMallDiscountnavigationinfo,
  apiMallDiscountpingtaimodify,
  apiMallDiscountzhijiangmodify,
  apiMallDiscountzhekoumodify,
  apiMallDiscountmanjianmodify,
  apiMallDiscountnavigationdel,
  apiMallnavigationstore,
  apiMallnavigationlists,
  apiMallnavigationinfo,
  apiMallnavigationmodify,
  apiMallnavigationdel,
  apiMallnavigationgoodsmodify,
  apiMalladnav,
  apiMalladstore,
  apiMalladlists,
  apiMalladinfo,
  apiMalladmodify,
  apiMalladdel,
  apiWarehousetagesstate,
  apiWarehousegoodsstate,
  apiMallpresentedstore,
  apiMallpresentedlists,
  apiMallpresentedinfo,
  apiMallpresentedmodify,
  apiMallpresenteddel,
  apiMallpresentedstate,
  apiDealeruserstate,
  apiWarehouseGoodsgroupstate,
  apiMallDiscountstate,
  apiSettingstate,
  apiWarehousegoodsfiles,
  apiMallNavstate,
  apiMalladnavlist,
  apiMalladgoodsads,
  apiSysstaticalls,
  apiSysstaticmodify,
  apiwarehousegoodscatalogchaoshi,
  apiwarehousegoodscatalogcancel,
  apiarehousegoodscatalogStore,
  apiWarehousebillsgoodscgtj,
  apiWarehousetagesfushufeiyong,
  apiWarehousebillsaccountvicelists,
  apiWarehousebillsbillsgoodsstatic,
  apiWarehousebillsselltongjidata,
  apiWarehousebillsbillssellgoods,
  apiOrdergoodsdaifamingxi,
  apiWarehousebillsaccountslists,
  apiDealeruserxiugaizhuangtai,
  apiWarehouseTaxfree,
  apiStatisticsdefaultdata,
  apiWarehousedowbillsncheck,
  apiWarehouseBatchshoukuan,
  apiOrderinvoicetongji,
  apiOrderinvoicetongjimingxi,
  apiOrderinvoicetongjidaishen,
  apiGoodsmakewarningRepertory,
  apiWarehousemakeuniqid,
  apiBillsinvoicetongji,
  apiWarehousebillsbillsinvoice,
  apiMarktingStore,
  apiMarktinglists,
  apiMarktingstate,
  apiMarktingdel,
  apiMarktingInfo,
  apiMarktingSend,
  apiWarehousetagesxchangelists,
  apiSyssynchronizationxchangexiangqing,
  apiSyssynchronizationxchangerenwu,
  apiSyssynchronizationxchangemakerenwu,
  apiWarehousetagesmakebangding,
  apiWarehousegoodsmakebangding,
  apiSyssynchronizationxchangeyouhuirenwuevent,
  apiSyssynchronizationxchangeyouhuimakerenwu,
  apiWarehousetagesxchangeyouhui,
  apiArticlestate,
  apiArticlecatalogcancel,
  apiArticleresetchaoshi,
  apiArticlecatalog,
  apiArticlecataloglist,
  apiWarehouseimportdatabind,
  apiMalldiscountcombinationinfo,
  apiMalldiscountcombinationstore,
  apiMalldiscountcombinationmodify,
  apiMalldiscountcombinationdel,
  apiMalldiscountcombinationstate,
  apiMalldiscountcombinationlists,
  apiArticlemakechangjianwenda,
  apiWarehousegoodsnavgoodsall,
  apiMalladmodifybar,
  apiMalladmodifyanniu,
  apiWarehousebillstiaozhengaccount,
  apiWarehousebillstiaozhengmodifyaccount,
  apiMalldiscountcodelists,
  apiMalldiscountcodeinfo,
  apiMalldiscountcodestore,
  apiMalldiscountcodemodify,
  apiMalldiscountcodedel,
  apiMalldiscountcodestate,
  apiMalldiscountcodeuselists,
  apiCrmdatacashbackloglists,
  apiCrmdatacashbacklists,
  apiOrdercataloggetLists,
  apiOrdercatalogstate,
  apiOrdercataloginfo,
  apiOrdercatalogmodify,
} from '../request/api';

export default {
  apiLogin(that, ob) {
    const skip = ob.skip;
    // 遮罩
    EventBus.$emit('globalZhezhaoBoxFun', true);
    // 加载中
    that.isLoading = true;
    // 鉴权号
    if (!ob.k) {
      ob.k = that.$route.query.k;
    }
    // 获取完整网址
    ob.url = window.location.href;
    // 发起请求
    return apiUserlogin(ob).then((ob) => {
      if (ob.state === 200) {
        // 初始化时间戳
        let times;
        // 执行写入本地 保持登录1天
        if (that.isCheck) {
          // 保持7天
          times = 60 * 60 * 24 * 7 * 1000;
          // times = 60 * 60 * 24 * 1000;
        } else {
          // 保持1天
          times = 60 * 60 * 24 * 1000;
        }
        // 写入缓存
        const result = commons.saveTodos('localUser', ob.data, times, 0);
        // 存储结果
        if (result) {
          // 更新本地路由的登录信息
          that.$store.commit(types.SAVE_LOCALUSER, { bool: true });
          if (skip) {
            // 跳转路由
            that.$router.push({ path: '/home', query: { time: Date.now() } });
          }
          // 取消遮罩
          EventBus.$emit('globalZhezhaoBoxFun', false);
          // 取消加载
          that.isLoading = false;
          // 登陆成功
          that.$message.showMsgBox({ type: 'success', content: '登陆成功' });
        } else {
          // 登陆失败
          that.$message.showMsgBox({ type: 'warning', content: '登陆失败' });
          // 取消遮罩
          EventBus.$emit('globalZhezhaoBoxFun', false);
          // 取消加载
          that.isLoading = false;
        }
      } else {
        // 登陆失败
        that.$message.showMsgBox({ type: 'warning', content: ob.message });
        // 取消遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 取消加载
        that.isLoading = false;
      }
      return ob;
    }).catch((ob) => {
      // 登陆失败
      that.$message.showMsgBox({ type: 'warning', content: '网络失败' });
      // 取消遮罩
      EventBus.$emit('globalZhezhaoBoxFun', false);
      // 取消加载
      that.isLoading = false;
      return { state: 201, message: '网络错误' };
    });
  },
  // 用户基本信息
  apiUserinfo(that, ob) {
    return apiUserinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticsdefaultdata(that, ob) {
    return apiStatisticsdefaultdata(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 部门列表
  apiDepartment(that, ob) {
    return apiDepartment(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 角色列表
  apiRole(that, ob) {
    return apiRole(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改个人信息
  apiUsermodify(that, ob) {
    return apiUsermodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 添加账号
  apiUserstore(that, ob) {
    return apiUserstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiMarktingStore(that, ob) {
    return apiMarktingStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiMarktingstate(that, ob) {
    return apiMarktingstate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiMarktingdel(that, ob) {
    return apiMarktingdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiMarktingInfo(that, ob) {
    return apiMarktingInfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改个人信息
  apiUserdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiUserdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiUserlists(that, obj) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiUserlists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },

  // 账号列表
  apiMarktingSend(that, obj) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiMarktingSend(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  // 账号列表
  apiMarktinglists(that, obj) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiMarktinglists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  // 登录日志
  apiUserlogs(that, obj) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiUserlogs(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
        // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiUserall(that, ob) {
    return apiUserall(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsercontrolinfo(that, ob) {
    return apiUsercontrolinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改个人信息
  apiUsercontrolmodify(that, ob) {
    return apiUsercontrolmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 添加账号
  apiUsercontrolstore(that, ob) {
    return apiUsercontrolstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改个人信息
  apiUsercontroldel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiUsercontroldel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiUsercontrollists(that, obj) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiUsercontrol(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiRoleinfo(that, ob) {
    return apiRoleinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改个人信息
  apiRolemodify(that, ob) {
    return apiRolemodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 添加账号
  apiRolestore(that, ob) {
    return apiRolestore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改个人信息
  apiRoledel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiRoledel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiUserlogsalls(that, obj) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiUserlogsalls(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
        // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 账号列表
  apiRolelists(that, obj) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiRolelists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
        // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 添加账号
  apiUsercolleague(that, ob) {
    return apiUsercolleague(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsercolleagueinfo(that, ob) {
    return apiUsercolleagueinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsercolleaguemodify(that, ob) {
    return apiUsercolleaguemodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiTagesalls(that, ob) {
    return apiTagesalls(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiTagesdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiTagesdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiTagesmodify(that, ob) {
    return apiTagesmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiTagesstore(that, ob) {
    return apiTagesstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiTagesinfo(that, ob) {
    return apiTagesinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiResumetagesalls(that, ob) {
    return apiResumetagesalls(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumetagesdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiResumetagesdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiResumetagesmodify(that, ob) {
    return apiResumetagesmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumetagesstore(that, ob) {
    return apiResumetagesstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumetagesinfo(that, ob) {
    return apiResumetagesinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiResumetagesArr(that, ob) {
    return apiResumetagesArr(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumepositionArr(that, ob) {
    return apiResumepositionArr(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiResumelist(that, obj) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiResumelist(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
        // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiResumeliststore(that, ob) {
    return apiResumeliststore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumelistmodify(that, ob) {
    return apiResumelistmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumelistinfo(that, ob) {
    return apiResumelistinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumeRefreshlist(that, ob) {
    return apiResumeRefreshlist(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumelistdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiResumelistdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiResumeinterview(that, ob) {
    return apiResumeinterview(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumeinterviewstore(that, ob) {
    return apiResumeinterviewstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumeinterviewdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiResumeinterviewdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiResumetrace(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiResumetrace(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
        // 请求成功了
          if (reload) {
            that.data = ob.data.list;
          } else {
            ob.data.list.forEach((item) => {
              that.data.push(item);
            });
          }
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiResumetracestore(that, ob) {
    return apiResumetracestore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiResumeinterviewlist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiResumeinterview(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
        // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiResumeworktable(that, ob) {
    return apiResumeworktable(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiSignevent(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiSignevent(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
        // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiSigneventusers(that, ob) {
    return apiSigneventusers(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumeinterviewrefreshlist(that, ob) {
    return apiResumeinterviewrefreshlist(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSigneventstore(that, ob) {
    return apiSigneventstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSigneventinfo(that, ob) {
    return apiSigneventinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSigneventmodify(that, ob) {
    return apiSigneventmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSigneventdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiSigneventdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiSignlog(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiSignlog(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
        // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiSignloginfo(that, ob) {
    return apiSignloginfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSigneventjoinlist(that, ob) {
    return apiSigneventjoinlist(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticsvisitmy(that, ob) {
    return apiStatisticsvisitmy(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticsvisitmyline(that, ob) {
    return apiStatisticsvisitmyline(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticsvisitall(that, ob) {
    return apiStatisticsvisitall(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticsvisitallline(that, ob) {
    return apiStatisticsvisitallline(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiUsernotice(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiUsernotice(obj).then((ob) => {
      if (ob.state === 200) {
      // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
      // 没有更多了
        if (ob.data.totalPages === 0) {
        // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
        // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
      // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiUsernoticestore(that, ob) {
    return apiUsernoticestore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsernoticeinfo(that, ob) {
    return apiUsernoticeinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsernoticemodify(that, ob) {
    return apiUsernoticemodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsernoticedel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiUsernoticedel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiUsercontacts(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiUsercontacts(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.dataA = [];
          that.dataB = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          if (item.type === '1') {
            that.dataA.push(item);
          } else {
            that.dataB.push(item);
          }
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
      // 没有更多了
        if (ob.data.totalPages === 0) {
        // 没有任何数据
          that.dataA = [];// 清空
          that.dataB = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
        // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
      // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiUsercontactsstore(that, ob) {
    return apiUsercontactsstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsercontactsinfo(that, ob) {
    return apiUsercontactsinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsercontactsmodify(that, ob) {
    return apiUsercontactsmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsercontactsdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiUsercontactsdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiMemo(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiMemo(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiMemostore(that, ob) {
    return apiMemostore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiMemoinfo(that, ob) {
    return apiMemoinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiMemomodify(that, ob) {
    return apiMemomodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiMemodel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiMemodel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiMessage(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiMessage(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiMessagestate(that, ob) {
    return apiMessagestate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticshome(that, ob) {
    return apiStatisticshome(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmTages(that, ob) {
    return apiCrmTages(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiCrmlist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmlist(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 账号列表
  apiCrmLogs(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmLogs(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmInfo(that, ob) {
    return apiCrmInfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiCrmTrace(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmTrace(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        that.diffuser = ob.data.diffuser;
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.clientNumber = ob.data.clientNumber;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.clientNumber = 0;
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 账号列表
  apiViewlogs(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiViewlogs(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.clientNumber = ob.data.clientNumber;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.clientNumber = 0;
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmTraceLabel(that, ob) {
    return apiCrmTraceLabel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUserZaizhi(that, ob) {
    return apiUserZaizhi(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmTracestore(that, ob) {
    return apiCrmTracestore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmModify(that, ob) {
    return apiCrmModify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiCrmContact(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmContact(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmContactStore(that, ob) {
    return apiCrmContactStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmContactDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmContactDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiCrmPact(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmPact(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmPactStore(that, ob) {
    return apiCrmPactStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmPactDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmPactDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmPactTages(that, ob) {
    return apiCrmPactTages(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiCrmFiles(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmFiles(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmFilesStore(that, ob) {
    return apiCrmFilesStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmFilesDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmFilesDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },

  apiCrmShare(that, ob) {
    return apiCrmShare(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmDutyuid(that, ob) {
    return apiCrmDutyuid(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmSetchance(that, ob) {
    return apiCrmSetchance(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmSetclient(that, ob) {
    return apiCrmSetclient(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmBlackapply(that, ob) {
    return apiCrmBlackapply(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmProtect(that, ob) {
    return window.swal({
      title: '确定转换吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmProtect(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmSetlatent(that, ob) {
    return apiCrmSetlatent(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmStore(that, ob) {
    return apiCrmStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUpdatetoken(that, ob) {
    return apiUpdatetoken(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmRecover(that, ob) {
    return apiCrmRecover(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiBindinginfo(that, ob) {
    return apiBindinginfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },


  // 账号列表
  apiCrmblacklists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmblacklists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmblackdel(that, ob) {
    return window.swal({
      title: '确定转换吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmblackdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmblackstore(that, ob) {
    return apiCrmblackstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmblackmodify(that, ob) {
    return apiCrmblackmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmblackinfo(that, ob) {
    return apiCrmblackinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmchancehome(that, ob) {
    return apiStatisticscrmchancehome(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmchancedataone(that, ob) {
    return apiStatisticscrmchancedataone(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmchancedatatow(that, ob) {
    return apiStatisticscrmchancedatatow(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdataone(that, ob) {
    return apiStatisticscrmdataone(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdatatow(that, ob) {
    return apiStatisticscrmdatatow(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdatathree(that, ob) {
    return apiStatisticscrmdatathree(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdatafour(that, ob) {
    return apiStatisticscrmdatafour(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdatafive(that, ob) {
    return apiStatisticscrmdatafive(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmPactInfo(that, ob) {
    return apiCrmPactInfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 退货获取初始化信息
  apiWarehousebillsreturninfo(that, ob) {
    return apiWarehousebillsreturninfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiCrmPactTrace(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmPactTrace(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        that.diffuser = ob.data.diffuser;
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmPactTracestore(that, ob) {
    return apiCrmPactTracestore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiCrmPactFiles(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmPactFiles(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmPactFilesStore(that, ob) {
    return apiCrmPactFilesStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmPactFilesDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmPactFilesDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmdestroy(that, ob) {
    return window.swal({
      title: '确定销毁吗?',
      text: '销毁客户数据及所有相关联的数据及文件',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        that.isSearchLoading = true;
        return apiCrmdestroy(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmTracedel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      text: '删除这条跟进记录',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmTracedel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmsavezhuangtai(that, ob) {
    return window.swal({
      title: '确定修改吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmsavezhuangtai(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },

  apiCrmcontactrepeat(that, ob) {
    return apiCrmcontactrepeat(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiCrmImport(that, ob) {
    return apiCrmImport(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmImportshow(that, ob) {
    return apiCrmImportshow(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousereadbillsexcel(that, ob) {
    return apiWarehousereadbillsexcel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdatahome(that, ob) {
    return apiStatisticscrmdatahome(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsertongshi(that, ob) {
    return apiUsertongshi(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmviewcontact(that, ob) {
    return apiCrmviewcontact(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticsviewlogs(that, ob) {
    return apiStatisticsviewlogs(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmmap(that, ob) {
    return apiCrmmap(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiNodealls(that, ob) {
    return apiNodealls(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSignbinding(that, ob) {
    return apiSignbinding(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSignfindtoken(that, ob) {
    return apiSignfindtoken(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSignmakeqrcode(that, ob) {
    return apiSignmakeqrcode(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiExternalsign(that, ob) {
    return apiExternalsign(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiExternalsigninfo(that, ob) {
    return apiExternalsigninfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },


  // 仓库接口方法
  apiWarehousetages(that, ob) {
    return apiWarehousetages(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousetagesstate(that, ob) {
    return apiWarehousetagesstate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealeruserstate(that, ob) {
    return apiDealeruserstate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousegoodsstate(that, ob) {
    return apiWarehousegoodsstate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiArticlestate(that, ob) {
    return apiArticlestate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiDealeruserxiugaizhuangtai(that, ob) {
    return apiDealeruserxiugaizhuangtai(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousetagesstore(that, ob) {
    return apiWarehousetagesstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousetagesdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      text: '删除这条跟进记录',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiWarehousetagesdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiWarehousetagesinfo(that, ob) {
    return apiWarehousetagesinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousetagesmodify(that, ob) {
    return apiWarehousetagesmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousebillsstoreaccounts(that, ob) {
    return apiWarehousebillsstoreaccounts(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseUpdateBillsinfo(that, ob) {
    return apiWarehouseUpdateBillsinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousegoodscatalog(that, ob) {
    return apiWarehousegoodscatalog(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },


  apiWarehousegoodslistaaa(that, obj, reload = false) {
    if (obj.whereType === 1) {
      // 请求中
      if (isNaN(that.repeatKey)) {
        that.repeatKey = 0;
      }
      that.repeatKey += 1;
      that.whereObj.repeatKey = that.repeatKey;
      that.goodsArr = [];
      // 执行获取个人信息的请求
      return apiWarehousegoodslist(obj).then((ob) => {
        // 写入新的数据
        if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
          that.goodsArr = ob.data.list;
          that.data.forEach((app) => {
            const info = that.goodsArr.find(apps => apps.uniqueID === app.goods_id);
            if (typeof info !== 'undefined') {
              info.isCheck = true;
            }
          });
        }
        return {};
      }).catch((ob) => {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        return ob;
      });
    }
    // 请求中
    if (isNaN(that.repeatKey2)) {
      that.repeatKey2 = 0;
    }
    that.repeatKey2 += 1;
    that.whereObj2.repeatKey2 = that.repeatKey2;
    that.goodsArrZengsong = [];
    // 执行获取个人信息的请求
    return apiWarehousegoodslist(obj).then((ob) => {
      // 写入新的数据
      if (ob.data.repeatKey2 * 1 === that.repeatKey2 * 1) {
        that.goodsArrZengsong = ob.data.list;
        that.dataZengsong.forEach((app) => {
          const info = that.goodsArrZengsong.find(apps => apps.uniqueID === app.goods_id);
          if (typeof info !== 'undefined') {
            info.isCheck = true;
          }
        });
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      return ob;
    });
  },
  apiWarehousegoodslistDown(that, obj) {
    // 执行获取个人信息的请求
    return apiWarehousegoodslist(obj).then(ob => ob).catch(ob => ob);
  },
  apiWarehouseresetchaoshi(that, obj) {
    // 执行获取个人信息的请求
    return apiWarehouseresetchaoshi(obj).then(ob => ob).catch(ob => ob);
  },
  apiSettingsetshipments(that, obj) {
    // 执行获取个人信息的请求
    return apiSettingsetshipments(obj).then(ob => ob).catch(ob => ob);
  },
  apiDiscountCheckGoodslist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousegoodslist(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            // 判断是否选中状态
            const isCheck = that.checkArr.find(app => item.uniqueID * 1 === app.id * 1);
            that.data.push({
              id: item.uniqueID,
              name: item.name,
              isCheck: !!isCheck,
            });
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiWarehousegoodslistb(that, obj, reload = false) {
    // 执行获取个人信息的请求
    return apiWarehousegoodslist(obj).then(ob => ob).catch(ob => ob);
  },

  apiwarehousegoodscatalogchaoshi(that, obj, reload = false) {
    // 执行获取个人信息的请求
    return apiwarehousegoodscatalogchaoshi(obj).then(ob => ob).catch(ob => ob);
  },


  apiWarehousegoodslist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousegoodslist(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiWarehousegoodstagesarr(that, ob) {
    return apiWarehousegoodstagesarr(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousegoodsstore(that, ob) {
    return apiWarehousegoodsstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousegoodsinfo(that, ob) {
    return apiWarehousegoodsinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousegoodsrefreshlist(that, ob) {
    return apiWarehousegoodsrefreshlist(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiwarehousegoodscatalogcancel(that, ob) {
    return apiwarehousegoodscatalogcancel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiArticlecatalogcancel(that, ob) {
    return apiArticlecatalogcancel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiArticleresetchaoshi(that, obj) {
    // 执行获取个人信息的请求
    return apiArticleresetchaoshi(obj).then(ob => ob).catch(ob => ob);
  },
  apiArticlecatalog(that, ob) {
    return apiArticlecatalog(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiArticlecataloglist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiArticlecataloglist(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  apiWarehousegoodsdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      text: '删除这个商品',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiWarehousegoodsdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiWarehousemakeuniqid(that, ob) {
    return apiWarehousemakeuniqid(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousegoodsmodify(that, ob) {
    return apiWarehousegoodsmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousegoodsimgs(that, ob) {
    return apiWarehousegoodsimgs(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiarehousegoodscatalogStore(that, ob) {
    return apiarehousegoodscatalogStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousegoodsimgsdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      text: '删除这个图片吗',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiWarehousegoodsimgsdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiWarehousebillinit(that, ob) {
    return apiWarehousebillinit(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousemakebatchsearch(that, ob) {
    return apiWarehousemakebatchsearch(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousecheckclient(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousecheckclient(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiWarehousesearchingrepertory(that, ob) {
    return apiWarehousesearchingrepertory(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousemakebatchaccount(that, ob) {
    return apiWarehousemakebatchaccount(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousecheckzhanghu(that, ob) {
    return apiWarehousecheckzhanghu(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousegetclientyingshou(that, ob) {
    return apiWarehousegetclientyingshou(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousestorebills(that, ob) {
    return apiWarehousestorebills(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousetimedtask(that, ob) {
    return apiWarehousetimedtask(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousealltages(that, ob) {
    return apiWarehousealltages(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousebillsinfo(that, ob) {
    return apiWarehousebillsinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousebillstiaozhengaccount(that, ob) {
    return apiWarehousebillstiaozhengaccount(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousebillstiaozhengmodifyaccount(that, ob) {
    return apiWarehousebillstiaozhengmodifyaccount(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseBillsStoreReturn(that, ob) {
    return apiWarehouseBillsStoreReturn(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiMakewarehousegoodsnum(that, ob) {
    return apiMakewarehousegoodsnum(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatistcssjtjcangku(that, ob) {
    return apiStatistcssjtjcangku(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatistcswarehousejxsdata(that, ob) {
    return apiStatistcswarehousejxsdata(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiGoodsmakewarningRepertory(that, ob) {
    return apiGoodsmakewarningRepertory(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatistcswarehousejxsline(that, ob) {
    return apiStatistcswarehousejxsline(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiOnerepertory(that, ob) {
    return apiOnerepertory(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousebillscancellation(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      text: '此方法不可替代【退货】操作，此操作将只作废【此单据】和衍生的【账单来往】，为了避免关联商品库存数据出现紊乱（出库退货交织导致库存和金额错误），相关的商品库存变化请另行处理！',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiWarehousebillscancellation(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },

  apiWarehousebillsgoods(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousebillsgoods(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  apiWarehouseselllog(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehouseselllog(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            if (item.is_state === '2') {
              item.badgeOb = { is_state: 1, title: '已作废' };
            } else if (item.unfinished_money === '0.00') {
              item.badgeOb = { is_state: 1, title: '已结清' };
            } else if (item.type === '1') {
              item.badgeOb = { is_state: 2, title: '收款中' };
            } else if (item.type === '2') {
              item.badgeOb = { is_state: 2, title: '退款中' };
            } else if (item.type === '3') {
              item.badgeOb = { is_state: 3, title: '付款中' };
            } else {
              item.badgeOb = { is_state: 2, title: '退款中' };
            }
            if (item.type === '1') {
              item.typeTitle = '销售';
            } else if (item.type === '2') {
              item.typeTitle = '退货';
            } else if (item.type === '3') {
              item.typeTitle = '采购';
            } else {
              item.typeTitle = '采退';
            }
            item.makeRemainingMoney = 0;
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  apiWarehousesearchserial(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousesearchserial(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        console.log(111);
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 激活码库
          that.data = ob.data.list;

          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  apiWarehousesearchproduct(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousesearchproduct(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  apiWarehouserepertory(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehouserepertory(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiWarehouserepertoryDown(that, obj) {
    // 执行获取个人信息的请求
    return apiWarehouserepertory(obj).then(ob => ob).catch(ob => ob);
  },
  apiWarehousebillsaccounts(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousebillsaccounts(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },

  apiOrdercataloggetLists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiOrdercataloggetLists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiOrdercatalogstate(that, ob) {
    return apiOrdercatalogstate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseBillsStoreAccounts(that, ob) {
    return apiWarehouseBillsStoreAccounts(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseaccountsinfo(that, ob) {
    return apiWarehouseaccountsinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseBillsDelAccounts(that, ob) {
    return apiWarehouseBillsDelAccounts(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseGoodsNumDetail(that, ob) {
    return apiWarehouseGoodsNumDetail(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiOrdercataloginfo(that, ob) {
    return apiOrdercataloginfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 经销商
  apiDealeruserdel(that, ob) {
    return apiDealeruserdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealeruserremove(that, ob) {
    return apiDealeruserremove(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealeruserStore(that, ob) {
    return apiDealeruserStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealeruserInfo(that, ob) {
    return apiDealeruserInfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealeruserModify(that, ob) {
    return apiDealeruserModify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousecheckgoodstages(that, ob) {
    return apiWarehousecheckgoodstages(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiOrdercatalogmodify(that, ob) {
    return apiOrdercatalogmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 经销商 - 用户队列
  apiDealeruserlist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiDealeruserlist(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },

  // 经销商授权
  apiDealerimpowerlist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiDealerimpowerlist(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiDealerimpowerone(that, ob) {
    return apiDealerimpowerone(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerImpowerStore(that, ob) {
    return apiDealerImpowerStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerImpowerModify(that, ob) {
    return apiDealerImpowerModify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerImpowerdel(that, ob) {
    return apiDealerImpowerdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },


  // 经销商授权
  apiDealerdiscountlist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiDealerdiscountlist(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiDealerdiscountone(that, ob) {
    return apiDealerdiscountone(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerDiscountStore(that, ob) {
    return apiDealerDiscountStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerDiscountModify(that, ob) {
    return apiDealerDiscountModify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerDiscountdel(that, ob) {
    return apiDealerDiscountdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseBatchshoukuan(that, ob) {
    return apiWarehouseBatchshoukuan(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerDiscountdelall(that, ob) {
    return apiDealerDiscountdelall(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },


  // 经销商授权
  apiDealerPricelist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiDealerPricelist(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiDealerPriceone(that, ob) {
    return apiDealerPriceone(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerPriceStore(that, ob) {
    return apiDealerPriceStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerPriceModify(that, ob) {
    return apiDealerPriceModify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerPricedel(that, ob) {
    return apiDealerPricedel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerPricedelall(that, ob) {
    return apiDealerPricedelall(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },


  // 经销商授权
  apiDealerOrderlist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiDealerOrderlist(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiDealerOrderone(that, ob) {
    return apiDealerOrderone(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  // 经销商授权
  apiDealerOrdersend(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiDealerOrdersend(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },

  // 经销商授权
  apiDealerOrdersendcode(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiDealerOrdersendcode(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          item.enterNum = '';
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.maxNum = ob.data.maxNum * 1;// 最大数
        that.sendTypeNum = ob.data.maxNum * 1;// 最大数
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        that.maxNum = ob.data.maxNum * 1;// 最大数
        that.sendTypeNum = ob.data.maxNum * 1;// 最大数
        console.log(that.maxNum, that.sendTypeNum);
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiDealerOrdersendgoods(that, ob) {
    return apiDealerOrdersendgoods(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerSendOne(that, ob) {
    return apiDealerSendOne(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousetagesmakebangding(that, ob) {
    return apiWarehousetagesmakebangding(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousegoodsmakebangding(that, ob) {
    return apiWarehousegoodsmakebangding(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 取消发货
  apiDealerOrdercancelsend(that, ob) {
    console.log(ob);
    if (ob.isPayment === '1') {
      return window.swal(
        {
          title: '当前订单【未付款】',
          text: '选择【取消并联动账单】时将对订单的金额进行重新计算修正；选择【直接取消】时则仅取消发货但不对订单金额做任何处理！',
          icon: 'warning',
          dangerMode: true,
          buttons: {
            cancel: '关闭',
            catch: {
              text: '取消并联动账单👉',
              value: 'catch',
            },
            defeat: {
              text: '直接取消👉',
              value: 'defeat',
            },
          },
          // eslint-disable-next-line consistent-return
        }).then((value) => {
        switch (value) {
          case 'defeat':
            return window.swal({
              title: '确定取消吗?',
              text: '仅取消发货，不联动账单',
              icon: 'warning',
              buttons: true,
              dangerMode: true,
            }).then((willDelete) => {
              if (willDelete) {
                that.isSearchLoading = true;
                ob.liandongMoney = 0;
                return apiDealerOrdercancelsend(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
              }
              return { state: 201, message: '取消成功' };
            });
            // eslint-disable-next-line no-unreachable
            break;
          case 'catch':
            return window.swal({
              title: '确定取消吗?',
              text: '取消发货并联动账单，对订单金额进行重新计算',
              icon: 'warning',
              buttons: true,
              dangerMode: 1,
            }).then((willDelete) => {
              if (willDelete) {
                that.isSearchLoading = true;
                ob.liandongMoney = 1;
                return apiDealerOrdercancelsend(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
              }
              return { state: 201, message: '取消成功' };
            });
            // eslint-disable-next-line no-unreachable
            break;
          default:
            console.log('关闭了');
        }
      });
    }
    return window.swal(
      {
        title: '当前订单【已付款】',
        text: '已付款订单请选择【直接取消】，仅取消发货但不对订单金额做任何处理，金额退款请另做处理！',
        icon: 'warning',
        dangerMode: true,
        buttons: {
          cancel: '关闭',
          defeat: {
            text: '直接取消👉',
            value: 'defeat',
          },
        },
        // eslint-disable-next-line consistent-return
      }).then((value) => {
      switch (value) {
        case 'defeat':
          return window.swal({
            title: '确定取消吗?',
            text: '仅取消发货，不联动账单',
            icon: 'warning',
            buttons: true,
            dangerMode: true,
          }).then((willDelete) => {
            if (willDelete) {
              that.isSearchLoading = true;
              ob.liandongMoney = 0;
              return apiDealerOrdercancelsend(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
            }
            return { state: 201, message: '取消成功' };
          });
          // eslint-disable-next-line no-unreachable
          break;
        default:
          console.log('关闭了');
      }
    });
  },
  // 取消订单
  apiDealerOrdercancel(that, ob) {
    that.isSearchLoading = true;
    return window.swal({
      title: '确定取消吗?',
      text: '提示：取消后关联的【出库单据】将同步被作废，同时将作废出库单衍生的【账单往来】数据，【库存模块】不受影响如要处理已发货/退货的商品需另行处理！',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiDealerOrdercancel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      that.isSearchLoading = false;
      return { state: 201, message: '取消成功' };
    });
  },


  // 经销商授权
  apiOrderinvoicetongjimingxi(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiOrderinvoicetongjimingxi(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  // 经销商授权
  apiOrderinvoicetongjidaishen(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiOrderinvoicetongjidaishen(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  // 经销商授权
  apiDealerOrderinvoice(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiDealerOrderinvoice(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiDealerOrderInvoiceSaveContent(that, ob) {
    return apiDealerOrderInvoiceSaveContent(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiOrderinvoicetongji(that, ob) {
    return apiOrderinvoicetongji(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiBillsinvoicetongji(that, ob) {
    return apiBillsinvoicetongji(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiDealerOrderInvoiceInfo(that, ob) {
    return apiDealerOrderInvoiceInfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerOrderInvoiceDelFiles(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiDealerOrderInvoiceDelFiles(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiDealerOrderInvoiceSaveState(that, ob) {
    return window.swal({
      title: ob.message,
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiDealerOrderInvoiceSaveState(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      that.isSearchLoading = false;

      return { state: 201, message: '取消成功' };
    });
  },
  apiWarehouseSaveGoodsContents(that, ob) {
    return window.swal({
      title: '确定修改吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiWarehouseSaveGoodsContents(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },


  // 经销商授权
  apiWarehousebillsbillsinvoice(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousebillsbillsinvoice(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },

  // 经销商授权
  apiWarehouseFilesList(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehouseFilesList(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiWarehouseFilesStore(that, ob) {
    return apiWarehouseFilesStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseFilesModify(that, ob) {
    return apiWarehouseFilesModify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseFilesDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiWarehouseFilesDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiWarehouseFilesInfo(that, ob) {
    return apiWarehouseFilesInfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },


  // 经销商授权
  apiArticleList(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return articleList(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiArticleStore(that, ob) {
    return articleStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiArticleModify(that, ob) {
    return articleModify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiArticleDel(that, ob) {
    return articleDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiArticleInfo(that, ob) {
    return articleInfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  // 经销商授权
  apiSysheadimgsList(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiSysheadimgsList(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiSysheadimgsStore(that, ob) {
    return apiSysheadimgsStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSysheadimgsModify(that, ob) {
    return apiSysheadimgsModify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSysheadimgsDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiSysheadimgsDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiSysheadimgsInfo(that, ob) {
    return apiSysheadimgsInfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  // 组合商品队列
  apiWarehouseGoodsgrouplist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehouseGoodsgrouplist(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 添加组合
  apiWarehouseGoodsgroupstore(that, ob) {
    return apiWarehouseGoodsgroupstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改组合
  apiWarehouseGoodsgroupmodify(that, ob) {
    return apiWarehouseGoodsgroupmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 组合详情
  apiWarehouseGoodsgroupinfo(that, ob) {
    return apiWarehouseGoodsgroupinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 删除组合
  apiWarehouseGoodsgroupdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiWarehouseGoodsgroupdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiWarehouseGoodsgroupstate(that, ob) {
    return apiWarehouseGoodsgroupstate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSettingstate(that, ob) {
    return apiSettingstate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousegoodsfiles(that, ob) {
    return apiWarehousegoodsfiles(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 数据统计
  apiDealerhome(that, ob) {
    return apiDealerhome(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiDealerone(that, ob) {
    return apiDealerone(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousehome(that, ob) {
    return apiWarehousehome(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseone(that, ob) {
    return apiWarehouseone(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },


  // 经销商
  apiWarehousesupplierdel(that, ob) {
    return apiWarehousesupplierdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousesupplierremove(that, ob) {
    return apiWarehousesupplierremove(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousesupplierStore(that, ob) {
    return apiWarehousesupplierStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousesupplierInfo(that, ob) {
    return apiWarehousesupplierInfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousesupplierModify(that, ob) {
    return apiWarehousesupplierModify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehousesearchcode(that, ob) {
    return apiWarehousesearchcode(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseimport(that, ob) {
    return apiWarehouseimport(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseimportdata(that, ob) {
    return apiWarehouseimportdata(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWarehouseimportdatabind(that, ob) {
    return apiWarehouseimportdatabind(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmgysall(that, ob) {
    return apiCrmgysall(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 经销商 - 用户队列
  apiWarehousesupplierlist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousesupplierlist(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiWarehousebillsbillsgoodsstatic(that, obj) {
    // 执行获取个人信息的请求
    return apiWarehousebillsbillsgoodsstatic(obj).then(ob => ob).catch(ob => ob);
  },
  apiWarehousebillsselltongjidata(that, obj) {
    // 执行获取个人信息的请求
    return apiWarehousebillsselltongjidata(obj).then(ob => ob).catch(ob => ob);
  },


  apiWarehousebillsaccountslists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousebillsaccountslists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },

  apiOrdergoodsdaifamingxi(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiOrdergoodsdaifamingxi(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },

  apiWarehousebillsbillssellgoods(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousebillsbillssellgoods(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  apiWarehousebillsgoodscghz(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousebillsgoodscghz(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
        // 没有更多了
          if (ob.data.totalPages === 0) {
          // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
          // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
        // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },

  apiWarehousebillsaccountvicelists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj2.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousebillsaccountvicelists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  apiWarehousebillsgoodscgtj(that, obj) {
    // 执行获取个人信息的请求
    return apiWarehousebillsgoodscgtj(obj).then(ob => ob).catch(ob => ob);
  },


  apiWarehousetagesfushufeiyong(that, obj) {
    // 执行获取个人信息的请求
    return apiWarehousetagesfushufeiyong(obj).then(ob => ob).catch(ob => ob);
  },

  // 添加优惠券平台
  apiMallDiscountpingtaistore(that, obj) {
    // 执行获取个人信息的请求
    return apiMallDiscountpingtaistore(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallDiscountzhijiangstore(that, obj) {
    // 执行获取个人信息的请求
    return apiMallDiscountzhijiangstore(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallDiscountzhekoustore(that, obj) {
    // 执行获取个人信息的请求
    return apiMallDiscountzhekoustore(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallDiscountmanjianstore(that, obj) {
    // 执行获取个人信息的请求
    return apiMallDiscountmanjianstore(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallpresentedstore(that, obj) {
    // 执行获取个人信息的请求
    return apiMallpresentedstore(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallpresentedmodify(that, obj) {
    // 执行获取个人信息的请求
    return apiMallpresentedmodify(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallpresenteddel(that, obj) {
    // 执行获取个人信息的请求
    return apiMallpresenteddel(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallpresentedstate(that, obj) {
    // 执行获取个人信息的请求
    return apiMallpresentedstate(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallDiscountnavigationinfo(that, obj) {
    // 执行获取个人信息的请求
    return apiMallDiscountnavigationinfo(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallDiscountnavigationdel(that, obj) {
    // 执行获取个人信息的请求
    return apiMallDiscountnavigationdel(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallDiscountstate(that, obj) {
    // 执行获取个人信息的请求
    return apiMallDiscountstate(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallNavstate(that, obj) {
    // 执行获取个人信息的请求
    return apiMallNavstate(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallpresentedinfo(that, obj) {
    // 执行获取个人信息的请求
    return apiMallpresentedinfo(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallpresentedlists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiMallpresentedlists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 优惠券队列
  apiMallDiscountnavigation(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiMallDiscountnavigation(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiMallDiscountpingtaimodify(that, obj) {
    // 执行获取个人信息的请求
    return apiMallDiscountpingtaimodify(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallDiscountzhijiangmodify(that, obj) {
    // 执行获取个人信息的请求
    return apiMallDiscountzhijiangmodify(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallDiscountzhekoumodify(that, obj) {
    // 执行获取个人信息的请求
    return apiMallDiscountzhekoumodify(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallDiscountmanjianmodify(that, obj) {
    // 执行获取个人信息的请求
    return apiMallDiscountmanjianmodify(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallnavigationstore(that, obj) {
    // 执行获取个人信息的请求
    return apiMallnavigationstore(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallnavigationinfo(that, obj) {
    // 执行获取个人信息的请求
    return apiMallnavigationinfo(obj).then(ob => ob).catch(ob => ob);
  },
  apiMallnavigationmodify(that, obj) {
    // 执行获取个人信息的请求
    return apiMallnavigationmodify(obj).then(ob => ob).catch(ob => ob);
  },

  apiSysstaticalls(that, obj) {
    // 执行获取个人信息的请求
    return apiSysstaticalls(obj).then(ob => ob).catch(ob => ob);
  },
  apiSysstaticmodify(that, obj) {
    // 执行获取个人信息的请求
    return apiSysstaticmodify(obj).then(ob => ob).catch(ob => ob);
  },

  apiMalladlists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiMalladlists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiMallnavigationlists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiMallnavigationlists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiMallChecknavigationlists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiMallnavigationlists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            const isCheck = that.checkArr.find(app => item.id === app.id);
            that.data.push({
              id: item.id,
              name: item.name,
              isCheck: !!isCheck,
            });
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },

  apiWarehousetagesxchangeyouhui(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousetagesxchangeyouhui(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },

  apiMallnavigationdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiMallnavigationdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiMallnavigationgoodsmodify(that, obj) {
    // 执行获取个人信息的请求
    return apiMallnavigationgoodsmodify(obj).then(ob => ob).catch(ob => ob);
  },

  apiMalladnavlists(that, obj) {
    // 执行获取个人信息的请求
    return apiMalladnavlist(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalladgoodsads(that, obj) {
    // 执行获取个人信息的请求
    return apiMalladgoodsads(obj).then(ob => ob).catch(ob => ob);
  },


  apiMalladnav(that, obj) {
    // 执行获取个人信息的请求
    return apiMalladnav(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalladstore(that, obj) {
    // 执行获取个人信息的请求
    return apiMalladstore(obj).then(ob => ob).catch(ob => ob);
  },
  apiWarehousedowbillsncheck(that, obj) {
    // 执行获取个人信息的请求
    return apiWarehousedowbillsncheck(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalladinfo(that, obj) {
    // 执行获取个人信息的请求
    return apiMalladinfo(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalladmodify(that, obj) {
    // 执行获取个人信息的请求
    return apiMalladmodify(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalladmodifybar(that, obj) {
    // 执行获取个人信息的请求
    return apiMalladmodifybar(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalladmodifyanniu(that, obj) {
    // 执行获取个人信息的请求
    return apiMalladmodifyanniu(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalladdel(that, obj) {
    // 执行获取个人信息的请求
    return apiMalladdel(obj).then(ob => ob).catch(ob => ob);
  },
  apiWarehouseTaxfree(that, obj) {
    // 执行获取个人信息的请求
    return apiWarehouseTaxfree(obj).then(ob => ob).catch(ob => ob);
  },

  apiSyssynchronizationxchangexiangqing(that, obj) {
    // 执行获取个人信息的请求
    return apiSyssynchronizationxchangexiangqing(obj).then(ob => ob).catch(ob => ob);
  },
  apiSyssynchronizationxchangerenwu(that, obj) {
    // 执行获取个人信息的请求
    return apiSyssynchronizationxchangerenwu(obj).then(ob => ob).catch(ob => ob);
  },
  apiSyssynchronizationxchangeyouhuirenwuevent(that, obj) {
    // 执行获取个人信息的请求
    return apiSyssynchronizationxchangeyouhuirenwuevent(obj).then(ob => ob).catch(ob => ob);
  },
  apiSyssynchronizationxchangemakerenwu(that, obj) {
    // 执行获取个人信息的请求
    return apiSyssynchronizationxchangemakerenwu(obj).then(ob => ob).catch(ob => ob);
  },
  apiSyssynchronizationxchangeyouhuimakerenwu(that, obj) {
    // 执行获取个人信息的请求
    return apiSyssynchronizationxchangeyouhuimakerenwu(obj).then(ob => ob).catch(ob => ob);
  },

  apiWarehousetagesxchangelists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousetagesxchangelists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          // if (reload) {
          //   that.data = [];
          // }
          // 请求成功了
          that.data = ob.data.list;
          // ob.data.list.forEach((item) => {
          //   that.data.push(item);
          // });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  isPositiveInteger(value) {
    const regExp = /^[0-9]\d*$/;
    return regExp.test(value);
  },
  // 优惠券队列
  apiMalldiscountcombinationlists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiMalldiscountcombinationlists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiArticlemakechangjianwenda(that, obj) {
    // 执行获取个人信息的请求
    return apiArticlemakechangjianwenda(obj).then(ob => ob).catch(ob => ob);
  },
  apiWarehousegoodsnavgoodsall(that, obj) {
    // 执行获取个人信息的请求
    return apiWarehousegoodsnavgoodsall(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalldiscountcombinationinfo(that, obj) {
    // 执行获取个人信息的请求
    return apiMalldiscountcombinationinfo(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalldiscountcombinationstore(that, obj) {
    // 执行获取个人信息的请求
    return apiMalldiscountcombinationstore(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalldiscountcombinationmodify(that, obj) {
    // 执行获取个人信息的请求
    return apiMalldiscountcombinationmodify(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalldiscountcombinationdel(that, obj) {
    // 执行获取个人信息的请求
    return apiMalldiscountcombinationdel(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalldiscountcombinationstate(that, obj) {
    // 执行获取个人信息的请求
    return apiMalldiscountcombinationstate(obj).then(ob => ob).catch(ob => ob);
  },
  // 优惠券队列
  apiMalldiscountcodeuselists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiMalldiscountcodeuselists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 优惠券队列
  apiMalldiscountcodelists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiMalldiscountcodelists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiMalldiscountcodeinfo(that, obj) {
    // 执行获取个人信息的请求
    return apiMalldiscountcodeinfo(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalldiscountcodestore(that, obj) {
    // 执行获取个人信息的请求
    return apiMalldiscountcodestore(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalldiscountcodemodify(that, obj) {
    // 执行获取个人信息的请求
    return apiMalldiscountcodemodify(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalldiscountcodedel(that, obj) {
    // 执行获取个人信息的请求
    return apiMalldiscountcodedel(obj).then(ob => ob).catch(ob => ob);
  },
  apiMalldiscountcodestate(that, obj) {
    // 执行获取个人信息的请求
    return apiMalldiscountcodestate(obj).then(ob => ob).catch(ob => ob);
  },
  apiCrmdatacashbacklists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmdatacashbacklists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmdatacashbackloglists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmdatacashbackloglists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }
      return {};
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
};



// WEBPACK FOOTER //
// ./src/util/resultcommons.js